import { FC, HTMLAttributes, ReactNode } from "react";

type Props = {
  children: ReactNode;
};
type Style = HTMLAttributes<HTMLElement>["style"];

export const PdfPreviewContent: FC<Props> = ({ children }) => {
  const wrapper: Style = {
    // width: "210mm",
    // minHeight: "297mm",
    width: 595,
    height: 841,
    margin: "0 auto",
    padding: "20px",
    // fontFamily: '"Courier New", Courier, monospace',
    fontSize: "12px",
    lineHeight: "1.2",
    backgroundColor: "white",
    // color: "#000",
    // border: "1px solid #ddd",
    // boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  };


  return (
    <div style={wrapper} id="JR_PAGE_ANCHOR_REPORT_DOC_0_1" className="jrPage">
        {children}
    </div>
  );
}